import { createSelector } from 'reselect';

export const getChallengeQuestSteps = state => state.questWorkflowReducer.quests.quest100.steps;

export const getGameFailures = state => state.questWorkflowReducer.stepFailures;

export const getIsChallengeQuest = state => state.questWorkflowReducer.currentActiveQuestId === 0;

export const getIsChallengeQuestComplete = createSelector(
  [getChallengeQuestSteps],
  (steps) => {
    for (let i = 0, l = steps.length; i < l; i++) {
      const { levels, levelsMastered } = steps[i];
      if (levelsMastered.length < levels.length) {
        return false;
      }
    }
    return true;
  },
);

export const getAreAllQuestsAndChallengesComplete = ({ questWorkflowReducer, appSessionReducer }) => {
  const { product: currentProduct } = appSessionReducer;
  return questWorkflowReducer.areAllQuestsAndChallengesComplete?.[currentProduct];
};

export const isPracticeTabEnabled = ({ questWorkflowReducer }) => {
  const { showPracticeTab, currentActiveLocation } = questWorkflowReducer;
  return showPracticeTab || currentActiveLocation === '';
};

export const getPlacedMethod = state => state.questWorkflowReducer.placedMethod;
